export const hasActionsRights = permissions => permissions !== "station_viewer";

export const hasStartStopAllRights = permissions =>
  permissions === "station_user" || "station_admin";

export const hasKioskCreateRights = permissions =>
  permissions === "super_admin";

export const isRestrictedKioskUser = permissions =>
  permissions === "station_viewer" || "station_user";



// WEBPACK FOOTER //
// ./src/lib/permissions.js